// 引入 axios
import axios from "axios";


// 使用同源的 nginx 代理，自动匹配当前协议与域名，避免混合内容
const base = window.location.origin;
// 统一添加的路径前缀
const apiPrefix = '/api';
// 传送 json 格式的 get 请求
export const getRequest=(url,params)=>{
    return axios({
        method:'get',
        url:`${base}${apiPrefix}${url}`,
        params: params,
    })
}




// //本地直连后端
// let base = 'http://127.0.0.1:8888';
// //传送json格式的get请求
// export const getRequest=(url,params)=>{
//     return axios({
//         method:'get',
//         url:`${base}${url}`,
//         params: params,
//     })
// }
